import { ArrowDropDown, Comment as Comments } from "@mui/icons-material";
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Menu,
    MenuItem
} from "@mui/material";
import { red } from "@mui/material/colors";
import { styled } from "@mui/material/styles";
import get from "lodash/get";
import includes from "lodash/includes";
import { useState } from "react";
import SaveAndExitButton from "../../../common/js/components/SaveAndExitButton";
import constants from "./constants";

const PageToolbar = styled(Grid)({
    padding: "10px 0px",
    backgroundColor: "#fafafa",
    position: "sticky",
    top: "62px",
    zIndex: 2,
    marginBottom: "1vh",
});

const ProgressDiv = styled("div")({
    textAlign: "center",
    width: "5em",
    display: "inline-block",
});

const DeleteButton = styled(Button)({
    backgroundColor: red[500],
    color: "white",
    "&:hover": {
        backgroundColor: red[800],
    },
});

const StyledCommentsButton = styled(Button)({
    color: "black",
});

const PropertyToolbar = (props) => {
    const {
        confirmDialog,
        disableInputs,
        displayDeleteDialog,
        elementsSaving,
        handleApprovePropertyRequestAsDataEntry,
        handleChooseDisplayDeleteDialog,
        handleDeleteProperty,
        handleSave,
        handleSaveAndExit,
        handleSubmit,
        history,
        numComments,
        property,
        toggleComments,
        toggleConfirm,
        userProfile,
    } = props;

    const [actionAnchorEl, setActionAnchorEl] = useState(null);

    const handleApprovePropertyRequest = async (save, callback) => {
        const result = await handleApprovePropertyRequestAsDataEntry(save, callback);
        if (result.success) {
            history.push("/properties");
        }
    };
    const submitActions = {
        broker: {
            Draft: {
                buttonText: "Submit",
                submit: () => {
                    handleSubmit(true, null);
                },
                variant: "contained",
            },
            "Broker Action Required": {
                buttonText: "Submit",
                submit: () => {
                    handleSubmit(true, null);
                },
                variant: "contained",
            },
        },
        dataEntry: {
            Requested: {
                buttonText: "Approve",
                submit: () => {
                    handleApprovePropertyRequest(false, constants.urls.reassign_comp_to_broker);
                },
                variant: "contained",
            },
            "Update Requested": {
                buttonText: "Update",
                submit: () => {
                    handleApprovePropertyRequest(false, constants.urls.reassign_comp_to_broker);
                },
                variant: "contained",
            },
        },
        dataAdmin: {
            Requested: {
                buttonText: "Approve",
                submit: () => {
                    handleApprovePropertyRequest(false, constants.urls.reassign_comp_to_broker);
                },
                variant: "contained",
            },
            "Update Requested": {
                buttonText: "Update",
                submit: () => {
                    handleApprovePropertyRequest(false, constants.urls.reassign_comp_to_broker);
                },
                variant: "contained",
            },
        },
    };

    const handleCancel = () => {
        toggleConfirm(null);
    };

    const deleteProperty = async () => {
        const result = await handleDeleteProperty(property.propertyKey);
        if (result.success) {
            history.push("/properties");
        }
    };

    const saveAndExitProperty = async () => {
        const result = await handleSaveAndExit();
        if (result.success) {
            history.push("/properties");
        }
    };

    const mainAction = get(
        submitActions,
        `${userProfile.role}.${get(property, "propertyAttributes.propertyStatus", "")}`,
        null
    );

    const confirm = (url) => {};

    return (
        <PageToolbar container justifyContent="space-between" alignItems="center" spacing={16}>
            <Grid item>
                <h2 className="page-title">Property Request Form</h2>
            </Grid>

            <Grid item>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    {includes(
                        ["dataAdmin", "dataEntry", "general", "officeManager", "transition", "appraiser"],
                        userProfile.role
                    ) ? (
                        <DeleteButton
                            variant="outlined"
                            onClick={() => handleChooseDisplayDeleteDialog(true, property.propertyKey)}
                        >
                            Delete
                        </DeleteButton>
                    ) : (
                        ""
                    )}
                    <StyledCommentsButton disabled={Boolean(!property.propertyKey)} onClick={toggleComments}>
                        <Comments /> Comments ({numComments})
                    </StyledCommentsButton>

                    {elementsSaving.propertySaveAndExit ? (
                        <ProgressDiv>
                            <CircularProgress size={20} color="primary" />
                        </ProgressDiv>
                    ) : (
                        <SaveAndExitButton
                            onSave={handleSave}
                            onSaveAndExit={saveAndExitProperty}
                            disabled={disableInputs}
                        />
                    )}

                    {elementsSaving.propertySubmit ? (
                        <ProgressDiv>
                            <CircularProgress size={20} color="primary" />
                        </ProgressDiv>
                    ) : mainAction && mainAction.options ? (
                        <div style={{ position: "relative" }}>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={(event) => setActionAnchorEl(event.currentTarget)}
                                endIcon={<ArrowDropDown />}
                            >
                                {get(mainAction, "buttonText")}
                            </Button>
                            <Menu
                                anchorEl={actionAnchorEl}
                                open={Boolean(actionAnchorEl)}
                                onClose={() => setActionAnchorEl(null)}
                            >
                                {Object.keys(get(mainAction, "options", {})).map((x, i) => {
                                    let url = get(mainAction, `options.${x}`);
                                    return (
                                        <MenuItem
                                            key={i}
                                            onClick={() => {
                                                confirm(url);
                                                setActionAnchorEl(null);
                                            }}
                                        >
                                            {x}
                                        </MenuItem>
                                    );
                                })}
                            </Menu>
                        </div>
                    ) : mainAction !== null ? (
                        <Button variant="contained" color="secondary" onClick={() => toggleConfirm()}>
                            {mainAction.buttonText}
                        </Button>
                    ) : (
                        property && (
                            <Button disabled variant="contained">
                                {get(property, "propertyAttributes.propertyStatus", "")}
                            </Button>
                        )
                    )}
                </div>
            </Grid>
            <Dialog open={confirmDialog.open} maxWidth="xs" aria-labelledby="confirmation-dialog-title">
                <DialogTitle id="confirmation-dialog-title">Continue?</DialogTitle>
                <DialogContent>Are you sure you want to submit this status change?</DialogContent>
                <DialogActions>
                    <Button onClick={handleCancel} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={() => mainAction["submit"](confirmDialog.onSubmit)} color="primary">
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={displayDeleteDialog.open} maxWidth="xs" aria-labelledby="confirmation-dialog-title">
                <DialogTitle id="confirmation-dialog-title">Delete Property Request?</DialogTitle>
                <DialogContent>
                    Are you sure you want to permanently delete this property request? The property request cannot be
                    recovered once it has been deleted.
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => handleChooseDisplayDeleteDialog(false, property.propertyKey)}
                        color="primary"
                    >
                        No
                    </Button>
                    <Button onClick={deleteProperty} color="primary">
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        </PageToolbar>
    );
};

export default PropertyToolbar;
